export default "__VITE_ASSET__0be945e4__"